<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="90%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      @checkbox-change="(e) => (checkedRow = e)"
      :shipmentExpenseCode="shipmentExpenseCode"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="notCheck"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentExpenseCode: { type: String, default: '' },
  },
  data() {
    return {
      checkedRow: [],
    }
  },
  computed: {
    notCheck() {
      return !this.checkedRow || !this.checkedRow.length
    },
  },
  methods: {
    confirm() {
      if (this.notCheck) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
